"use strict";

import angular from "angular";

import template from "./nanda-chat-message-user.component.html";
import "./nanda-chat-message-user.component.scss";

class NandaChatMessageUserComponent {
    constructor() {}
}

NandaChatMessageUserComponent.$inject = [];

const name = "nandaChatMessageUserComponent";
const def = {
    bindings: {
        message: "<"
    },
    controller: NandaChatMessageUserComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
